import { useState, useEffect } from "react";
import moment from "moment";
import { IoIosCloseCircleOutline } from "react-icons/io";
import gplay from "../assets/images/google.svg";
import aplay from "../assets/images/facebook.svg";
const CheckOS = () => {
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    // if (width < 720) {
    // var OSName = "Unknown OS";
    // if (navigator.userAgent.indexOf("Win") != -1) OSName = "Windows";
    // if (navigator.userAgent.indexOf("Mac") != -1) OSName = "Macintosh";
    // if (navigator.userAgent.indexOf("Linux") != -1) OSName = "Linux";
    // if (navigator.userAgent.indexOf("Android") != -1) OSName = "Android";
    if (!(navigator.userAgent.indexOf("like Mac") !== -1)) {
      if (localStorage.getItem("expireTime")) {
        if (
          !moment().isBefore(JSON.parse(localStorage.getItem("expireTime")))
        ) {
          setShowModal(true);
          // localStorage.removeItem('expireTime');
          localStorage.setItem(
            "expireTime",
            JSON.stringify(new Date().getTime() + 24 * 60 * 60 * 1000)
          );
        }
      } else {
        console.log("object")
        setShowModal(true);
        localStorage.setItem(
          "expireTime",
          JSON.stringify(new Date().getTime() + 24 * 60 * 60 * 1000)
        );
      }
    }
    // }
  }, []);

  return !(navigator.userAgent.indexOf("like Mac") !== -1) && showModal ? (
    <div className="Register">
      <div className="Register__container" style={{ height: "50%" }}>
        <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={() => setShowModal(false)}
          />
        </div>
        <div className="Register__content">
          <h2>Download Coinstorey App on PlayStore </h2>
          <div className="Footer__appdownload">
            <img
              src={aplay}
              alt="fb"
              className="Footer__aplay"
              style={{ width: "50%", height: "auto" }}
            />
            <img
              src={gplay}
              alt="fb"
              className="Footer__gplay"
              style={{ width: "50%", height: "auto" }}
            />
          </div>
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CheckOS;
